import type Trail from '@alltrails/types/Trail';

export type HeroImage = {
  full?: string;
  medium?: string;
};

// TODO: update marketing CMS types to snake case https://alltrails.atlassian.net/browse/GROW-14089
export type Post = {
  id: number;
  title: string;
  content: string;
  date: string;
  slug: string;
  hero_image?: HeroImage;
  author: string;
  status: PostStatus;
  subtitle?: string | null;
  is_sponsored: boolean;
};

export type PostPreview = {
  id: number;
  title: string;
  excerpt: string;
  date: string;
  slug: string;
  hero_image?: HeroImage;
  category?: string | null;
  status: PostStatus;
  is_sponsored: boolean;
};

export type TrailListBlock = {
  unique_id: string;
  trails: Trail[];
  show_map: boolean;
};

export type PartnerListData = {
  id: number;
  title: string;
  slug: string;
  content: string;
  hero_image: HeroImage;
  hero_video_url: string;
  trail_list_blocks: TrailListBlock[];
  partner_list_header_html?: string;
  is_sponsored: boolean;
};

export enum LandingPageVariant {
  Primary = 'primary',
  Inverse = 'inverse'
}

export type TrailListItemData = {
  name: string;
  slug: string;
  avgRating?: number;
  reviewCount?: number;
  difficulty?: number;
  length?: number;
  durationMinutes?: number;
  photoId?: number;
  photoHash?: string;
};

export type ImageData = {
  src: string;
  caption?: string;
};

export type PostStatus = 'publish' | 'private' | 'pending' | 'future';
